import React from 'react';
import clsx from 'clsx';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '#web-components/components/Typography';
import DropdownMenu from '#web-components/components/DropdownMenu';
import styles from './AccountMenu.styles';

export interface AccountMenuProps {
  name: string,
  selected?: boolean,
  disabled?: boolean,
  children: React.ReactNode | Element[],
}

const useStyles = makeStyles(styles, { name: 'AccountMenu' });

export default function AccountMenu({
  name,
  selected,
  disabled,
  children,
}: AccountMenuProps): JSX.Element {
  const classes = useStyles();

  return (
    <Box className={classes.menu}>
      <DropdownMenu
        triggerElement={(
          <Typography data-xpath="accountMenu.name" variant="accentSmallCompact">{name}</Typography>
      )}
        classes={
        clsx(classes.name, {
          [classes.enabled]: !selected && !disabled,
          [classes.selected]: selected,
          [classes.disabled]: disabled,
        })
      }
        placement="top-start"
      >
        {children}
      </DropdownMenu>
    </Box>
  );
}
